<template>
  <div class="functionManage">
    <div class="container">
      <!--=========查询模块================-->
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px">
          <el-row :gutter="20">
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('sys.function.functionCN')" prop="functionNameCn">
                <el-input v-model="queryCondition.functionNameCn" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('sys.function.functionCode')" prop="functionCode">
                <el-input v-model="queryCondition.functionCode" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="1" :md="12" :lg="8" :xl="6">
              <el-form-item :label="$t('sys.function.functionMenuLevel')" prop="menuLevel">
                <el-input v-model="queryCondition.menuLevel" style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>

      <el-row class="action-btn-row">
        <el-button type="primary" @click="showFunctionDialog('add')">{{$t('common.addNew')}}</el-button>
        <el-button type="danger" v-acl="FunctionDelete" @click="delSelFunction">{{$t('common.del')}}</el-button>
      </el-row>
      <!--=========查询模块END================-->
      <!--=========数据列表================-->
      <el-table sortable max-height="435" :data="functionList" ref="functionDataTable" border highlight-current-row class="table">
        <el-table-column align="center" sortable prop="tmFunctionId" type="selection" width="55"></el-table-column>
        <!--<el-table-column sortable prop="tmFunctionId" :label="$t('sys.function.functionId')"></el-table-column>-->
        <el-table-column show-overflow-tooltip sortable prop="functionNameCn" :label="$t('sys.function.functionCN')">
          <template slot-scope="scope">
            <el-link class="el-link" type="primary" @click="showFunctionDialog('update',scope.row)"> {{scope.row.functionNameCn}} </el-link>
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="functionNameEn" :label="$t('sys.function.functionEN')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="functionCode" :label="$t('sys.function.functionCode')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="parentFunctionId" :label="$t('sys.function.parentFunctionId')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="menuNo" :label="$t('sys.function.functionNo')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="menuLevel" :label="$t('sys.function.functionMenuLevel')"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="icon" label="icon"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="title" label="title"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="functionIndex" label="functionIndex"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <!--=========数据列表END================-->
    <!--=========权限信息新增/编辑================-->
    <el-dialog :title="$t('sys.function.functionInfo')" :visible.sync="functionDialog" width="600px">
      <el-form :model="functionInfo" ref="functionInfoForm" :rules="functionRules" class="form_border" :label-position="labelPosition" label-width="135px">
        <el-row type="flex" justify="space-around">
          <el-col :span="16">
            <el-form-item :label="$t('sys.function.functionCN')" placeholder="" prop="functionNameCn">
              <el-input v-model="functionInfo.functionNameCn" />
            </el-form-item>

            <el-form-item :label="$t('sys.function.functionEN')" placeholder="" prop="functionNameEn">
              <el-input v-model="functionInfo.functionNameEn" />
            </el-form-item>

            <el-form-item :label="$t('sys.function.functionCode')" placeholder="" prop="functionCode">
              <el-input v-model="functionInfo.functionCode" />
            </el-form-item>

            <el-form-item :label="$t('sys.function.functionNo')" placeholder="" prop="menuNo">
              <el-input v-model="functionInfo.menuNo" />
            </el-form-item>

            <el-form-item :label="$t('sys.function.functionMenuLevel')" placeholder="" prop="menuLevel">
              <el-input v-model="functionInfo.menuLevel" />
            </el-form-item>

            <el-form-item :label="$t('sys.function.parentFunctionId')" placeholder="" prop="parentFunctionId">
              <el-input type="number" v-model="functionInfo.parentFunctionId" />
            </el-form-item>

            <el-form-item label="icon" placeholder="" prop="icon">
              <el-input v-model="functionInfo.icon" />
            </el-form-item>

            <el-form-item label="title" placeholder="" prop="title">
              <el-input v-model="functionInfo.title" />
            </el-form-item>

            <el-form-item label="functionIndex" placeholder="" prop="functionIndex">
              <el-input v-model="functionInfo.functionIndex" />
            </el-form-item>

            <el-form-item :label="$t('sys.function.functionIsMenu')" placeholder="" prop="isMenu">
              <el-select v-model="functionInfo.isMenu" class="handle-input">
                <!--<el-option :key="index" v-for="(item,index) in yesNoList" :label="item | inputChoiceI18n" :value="item.code"></el-option>-->
                <el-option key="1" label="是" value="Y"></el-option>
                <el-option key="2" label="否" value="N"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('sys.function.functionIsWhiteList')" placeholder="" prop="isWhiteList">
              <el-select v-model="functionInfo.isWhiteList" class="handle-input">
                <!-- <el-option :key="index" v-for="(item,index) in yesNoList" :label="item | inputChoiceI18n" :value="item.code"></el-option>-->
                <el-option key="1" label="是" value="Y"></el-option>
                <el-option key="2" label="否" value="N"></el-option>
              </el-select>
            </el-form-item>

          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" @click="functionDialog = false">{{$t('common.close')}}</el-button>
        <el-button type="primary" v-acl="FunctionSave" @click="saveFunction">{{$t('common.save')}}</el-button>
      </div>
    </el-dialog>
    <!--=========权限信息新增/编辑END================-->

  </div>
</template>
<script>
import { functionService } from "../../../api/user-manage/function";
import { inputChoiceService } from "../../../api/common/input-choice";
import { Message } from "element-ui";
import commonFunction from "../../../utils/dataTableUtils"
export default {
  name: 'role-manage',
  data() {
    return {
      functionList: [],
      totalCount: 0,
      labelPosition: 'right',
      queryCondition: { pageSize: 15, pageNum: 1, functionNameCn: "", functionNameEn: "", menuLevel: "" },
      functionDialog: false,
      functionInfo: {},
      functionRules: {
        functionNameCn: [
          { required: true, message: this.$t('sys.function.inputFunctionCN'), trigger: 'blur' }
        ],
        menuNo: [
          { required: true, message: this.$t('sys.function.inputFunctionNo'), trigger: 'blur' }
        ],
        menuLevel: [
          { required: true, message: this.$t('sys.function.inputMenuLevel'), trigger: 'blur' }
        ],
        parentFunctionId: [
          { required: true, message: this.$t('sys.function.inputParent'), trigger: 'blur' }
        ],
        isWhiteList: [
          { required: true, message: this.$t('sys.function.selectWhiteList'), trigger: 'blur' }
        ],
        functionCode: [
          { required: true, message: this.$t('sys.function.inputFunctionCode'), trigger: 'blur' }
        ]
      },
      functionIds: [],
      yesNoList: [],
    }
  },
  created() {
    this.queryData(1);
    this.getInputChoiceValues();
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      functionService.getFunctionData(this.queryCondition).then((res) => {
        this.functionList = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
    showFunctionDialog(method, row) {
      this.clearVlidate("functionInfoForm");
      this.functionInfo = {};
      if ('update' === method) {
        //将选种的传给roleInfo
        this.functionInfo = row;
      }
      this.functionDialog = true;
    },
    saveFunction: function () {
      let validFlag = false;
      this.$refs['functionInfoForm'].validate((valid) => {
        validFlag = valid;
      });
      if (!validFlag) {
        return;
      }
      functionService.saveOrUpdateFunction(this.functionInfo).then((res) => {
        if (res.meta.success) {
          Message({ message: this.$t('common.saveSuccess'), type: "success" });
          this.functionDialog = false;
          this.queryData();
        } else {
          Message({ message: res.meta.msg, type: "error" });
          this.queryData();
        }
      });
    },
    delSelFunction() {
      let rows = this.$refs.functionDataTable.selection;
      if (rows.length == 0) {
        Message({ message: this.$t('sys.function.selectDelFunction'), type: "warning" });
      } else {
        this.functionIds = [];
        rows.forEach((item) => {
          this.functionIds.push(item.tmFunctionId)
        });

        this.$confirm(this.$t('common.delWarning'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          cancelButtonClass: 'el-button--primary',
          confirmButtonClass: 'el-button--primary',
          type: 'warning'
        }).then(() => {
          functionService.deleteFunction(this.functionIds).then((res) => {
            if (res.meta.success) {
              Message({ message: this.$t('common.delSuccess'), type: "success" });
              this.queryData();
            } else {
              Message({ message: this.$t('common.delError'), type: "error" });
            }
            this.queryData();
          });
        }).catch(() => {

        });
      }
    },
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["COMMON:YES_NO_NUMBER"] = "COMMON:YES_NO_NUMBER";
      inputChoiceService.getInputChoiceValues(mapObj).then((res) => {
        this.yesNoList = res["COMMON:YES_NO_NUMBER"];
        console.log(res["COMMON:YES_NO_NUMBER"])
      });
    },
    //清除校验信息
    clearVlidate: function (refFormName) {
      if (this.$refs[refFormName]) {
        this.$refs[refFormName].clearValidate();
      }
    }
  },
  extends: commonFunction
}
</script>
<style scoped >
.handle-input {
  width: 95%;
}
.action-btn-row {
  margin-bottom: 10px;
  margin-top: 10px;
}

.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
.form_header {
  text-align: center;
  margin-bottom: 10px;
}
.functionManage .el-link {
  text-decoration: underline;
  color: #f8ab01 !important;
  cursor: pointer;
  font-size: 12px;
}
</style>
